export default "__VITE_ASSET__BIT28SQq__"